import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

axios.defaults.baseURL = process.env.REACT_APP_API_URL;

export const getClinicHairServiceMasterByClinicId = createAsyncThunk(
  "clinicHairServiceMaster/getClinicHairServiceMasterByClinicId",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "/clinicHairServiceMaster/getClinicHairServiceMasterByClinicId",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data.token
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message)
    }
  }
);

export const updateClinicHairServiceDetails = createAsyncThunk(
  "clinicHairServiceMaster/updateClinicHairServiceDetails",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        "/clinicHairServiceMaster/updateClinicHairServiceDetails",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data.token
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const deleteClinicHairServiceDetails = createAsyncThunk(
  "clinicHairServiceMaster/deleteClinicHairServiceDetails",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        "/clinicHairServiceMaster/deleteClinicHairServiceDetails",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data.token
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

const initialState = {
  loading: false,
  clinicHairServiceMasterByClinicId: [],
  updateClinicHairServiceMasterSuccessMessage: null,
  updateClinicHairServiceMasterErrorMessage: null,
  deleteClinicHairServiceDetailsSuccessMessage: null,
  deleteClinicHairServiceDetailsErrorMessage: null
};
const clinicHairServiceMasterSlice = createSlice({
  name: "clinicHairServiceMaster",
  initialState,
  reducers: {
    resetUpdateClinicHairServiceMasterMessage: (state) => {
      state.updateClinicHairServiceMasterSuccessMessage = null
      state.updateClinicHairServiceMasterErrorMessage = null
    },
    resetDeleteClinicHairServiceDetailsMessage: (state) => {
      state.deleteClinicHairServiceDetailsSuccessMessage = null
      state.deleteClinicHairServiceDetailsErrorMessage = null
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getClinicHairServiceMasterByClinicId.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getClinicHairServiceMasterByClinicId.fulfilled, (state, action) => {
        state.loading = false;

        state.clinicHairServiceMasterByClinicId = action.payload.result.list;
      })
      .addCase(getClinicHairServiceMasterByClinicId.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(updateClinicHairServiceDetails.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(updateClinicHairServiceDetails.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.success === false) {
          state.updateClinicHairServiceMasterErrorMessage = action.payload.result.message;
        } else {
          state.updateClinicHairServiceMasterSuccessMessage = action.payload.result.message;
        }
      })
      .addCase(updateClinicHairServiceDetails.rejected, (state, action) => {
        state.loading = false;
        state.updateClinicHairServiceMasterErrorMessage = action.payload;
      })
      .addCase(deleteClinicHairServiceDetails.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(deleteClinicHairServiceDetails.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.success === false) {
          state.deleteClinicHairServiceDetailsErrorMessage = action.payload.result.message;
        } else {
          state.deleteClinicHairServiceDetailsSuccessMessage = action.payload.result.message;
        }
      })
      .addCase(deleteClinicHairServiceDetails.rejected, (state, action) => {
        state.loading = false;
        state.deleteClinicHairServiceDetailsErrorMessage = action.payload;
      });
  },
});

export const {
  resetUpdateClinicHairServiceMasterMessage,
  resetDeleteClinicHairServiceDetailsMessage
} = clinicHairServiceMasterSlice.actions;

export default clinicHairServiceMasterSlice.reducer;
